module.exports = __webpack_public_path__ + "static/img/reChangJing3.0576d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reChangJing3.png
// module id = pfZM
// module chunks = 2